/* eslint-disable code-style/no-hardcoded-strings */

import { Box, styled } from "@mui/material";

export const StyledTable = styled(Box)(({ theme }) => ({
    "& .MuiPaper-root": { boxShadow: "none" },
    "& .MuiTableHead-root": {
        background: theme.palette.grey[theme.palette.mode === "dark" ? 900 : 200],
        borderRadius: theme.shape.borderRadius,
        fontWeight: "bolder",
    },
    "& .MuiTableRow-root": {
        "& .MuiTableCell-body": {
            "&:first-of-type :first-of-type": { fontWeight: "bold" },
            "& a": {
                display: "block",
                height: "100%",
                width: "100%",
            },
            borderBottom: `1px solid ${theme.palette.grey[300]}`,
            fontSize: "14px",
            padding: "8px 16px",
        },
        "& .MuiTableCell-head": {
            color: theme.palette.grey[600],
            fontWeight: "bold",
        },
        "& .MuiTypography-root": {
            "& .MuiTypography-caption": {
                color: theme.palette.grey[600],
                fontSize: "12px",
                fontWeight: "lighter",
                marginInline: "8px",
                textDecoration: "underline",
            },
        },
    },
    borderRadius: theme.shape.borderRadius,
}));

export const StyledTablePagination = styled(Box)({ "& .MuiInputBase-root": { marginLeft: "8px" } });
